import { createSelector } from '@ngrx/store';
import { BaseState } from '../base.state';

export const selectRecalculateValuationState = (state: BaseState) => state.recalculateValuation;

export const selectRecalculateValuationIsLoading = createSelector(
  selectRecalculateValuationState,
  (state) => state.isLoading
);
